import { html } from "htm/preact";
import { hydrate } from "preact";
import NewsletterCompact from "../components/NewsletterCompact.js";

const el = document.getElementById("newsletter-compact-island");
if (el) {
  const lang = el.dataset.lang;
  const signUpText = el.dataset.signuptext;
  const successMessage = el.dataset.successmessage;
  const errorMessage = el.dataset.errormessage;

  hydrate(
    html`<${NewsletterCompact} 
      lang=${lang}
      signUpText=${signUpText}
      successMessage=${successMessage}
      errorMessage=${errorMessage}
    />`, 
    el
  );
}
